import { Icon, IconProps } from "@/components/ui/icon";
import { ResourceItemReturnVariantProps } from "./resource-item.variants";
import { Spinner } from "@/components/ui/spinner";

export type ResourceItemIconProps = {
  iconName: string;
  styles: ResourceItemReturnVariantProps;
  isLoading: boolean;
};

const ResourceItemIcon = (props: ResourceItemIconProps) => {
  const { iconName, styles, isLoading } = props;
  if (isLoading) {
    return (
      <>
        <Spinner className={styles.loading()} />
        <span className={styles.loadingLabel()}>loading..</span>
      </>
    );
  }
  return <Icon name={iconName as IconProps["name"]} className={styles.icon()} />;
};

export default ResourceItemIcon;
